import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

type Options = {
  directMembersOnly?: boolean;
};

export const useGetOwnOrganizations = ({
  directMembersOnly = false
}: Options = {}) => {
  const { isAuthenticated } = useAuth();

  const api = useGrapevineOrganizationApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.OWN_ORGANIZATIONS, { directMembersOnly }],
    queryFn: () => api.getOwnOrganizations({ directMembersOnly }),
    enabled: isAuthenticated
  });
};
